import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'documents-links',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'documents-links',
            component: () => import('../pages/DocumentsLinksPage.vue')
          }
        ]
      }
    ]
  }
];

export default routes;
